"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProperty = void 0;

var getProperty = function getProperty(path, obj) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  // check input parameters
  if (!path || typeof path !== "string") {
    return defaultValue;
  }

  if (!obj) {
    return defaultValue;
  } // split path to array of keys


  var pathParts = path.split("."); // take first key create a node from that

  var pathPart = pathParts.shift();
  var node = obj[pathPart]; // if node not found return

  if (node === null || node === undefined) {
    return defaultValue;
  } // return final value or walk object tree


  if (pathParts.length === 0) {
    return node;
  } else {
    return getProperty(pathParts.join("."), node, defaultValue);
  }
};

exports.getProperty = getProperty;